export const OTP_INPUTS_NUM = 5;
